<template>

    <div class="error-auth" v-if="!isAuth">
        <div class="error-code">401</div>
        <div class="error-title">Unauthorized</div>
        <p class="error-text">Для доступа к этой странице необходимо авторизоваться</p>
        <div class="error-actions">
            <ButtonUI :title="'Главная'" variant="outline" @click="$router.push('/')"/>
            <ButtonUI :title="'Авторизация'" @click="$router.push('/auth')"/>
        </div>
    </div>

</template>


<script>

import ButtonUI from './ButtonUI.vue';

export default {
    name: 'ErrorAuthView',

    components: {
        ButtonUI
    },

    props: {
        isAuth: {
            type: Boolean,
            default: false
        }
    },
}

</script>


<style scoped>

.error-auth{
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 48px 0;
    margin-bottom: 20px;

    text-align: center;

    background: var(--card);
    border: 1px dashed var(--border);
    border-radius: var(--radius);
}

.error-code{
    font-size: 56px;
    font-weight: 700;
    letter-spacing: -0.03em;
    line-height: 1;
}

.error-title{
    margin-top: 8px;

    font-size: 16px;
    font-weight: 500;
    color: var(--muted-foreground);
}

.error-text{
    margin-top: 8px;

    font-size: 14px;
    color: var(--muted-foreground);
}

.error-actions{
    display: flex;
    gap: 10px;

    margin-top: 20px;
}

</style>
